import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-setupbankstatement',
  templateUrl: './setupbankstatement.component.html',
  styleUrls: ['./setupbankstatement.component.css']
})
export class SetupbankstatementComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  displayNext() {
    this.router.navigate(['/address']);
  }
}
